{
  "fr": {
    "sortGroups": {
      "date": "Date",
      "deadline": "Échéance",
      "name": "Nom"
    },
    "sorting": {
      "category_name_asc": "Catégorie A → Z",
      "category_name_desc": "Catégorie Z → A",
      "created_at_asc": "Plus ancien en premier",
      "created_at_desc": "Plus récent en premier",
      "deadline_date_asc": "Dernière échéance en premier",
      "deadline_date_desc": "Première échéance en premier",
      "due_date asc": "Dernière échéance en premier",
      "due_date desc": "Première échéance en premier",
      "group_name asc": "Nom A → Z",
      "group_name desc": "Nom Z → A",
      "group_name_asc": "Nom A → Z",
      "group_name_desc": "Nom Z → A",
      "last_name_asc": "Nom de famille A → Z",
      "last_name_desc": "Nom de famille Z → A",
      "messaged_all_at_nulls_first_asc": "Plus ancien en premier",
      "messaged_all_at_nulls_last_desc": "Plus récent en premier",
      "messaged_at_nulls_first_asc": "Plus ancien en premier",
      "messaged_at_nulls_last_desc": "Plus récent en premier",
      "name_asc": "Nom A → Z",
      "name_desc": "Nom Z → A",
      "name_lower asc": "Nom A → Z",
      "name_lower desc": "Nom Z → A",
      "name_lower_asc": "Nom A → Z",
      "name_lower_desc": "Nom Z → A",
      "notification_level_name_asc": "Unité A → Z",
      "notification_level_name_asc_sup": "Projet A → Z",
      "notification_level_name_desc": "Unité Z → A",
      "notification_level_name_desc_sup": "Projet Z → A",
      "session_started_at_asc": "Session plus ancienne en premier",
      "session_started_at_desc": "Session plus récente en premier",
      "status asc": "Statut A → Z",
      "status desc": "Statut Z → A",
      "status_name_asc": "Statut A → Z",
      "status_name_desc": "Statut Z → A",
      "unit_name_asc": "Unité A → Z",
      "unit_name_desc": "Unité Z → A",
      "unit_name_lower_asc": "Unité A → Z",
      "unit_name_lower_desc": "Unité Z → A",
      "updated_at asc": "Mis à jour le moins récemment",
      "updated_at desc": "Mis à jour récemment",
      "updated_at_asc": "Mis à jour le moins récemment",
      "updated_at_desc": "Mis à jour récemment"
    }
  }
}
